<script>
    import {Line} from 'vue-chartjs'
    export default {
        extends: Line,
        props: ['chartdata','type', 'title'],
        data() {
            return {
                options: {
                    responsive:true,
                    maintainAspectRatio:false,
                    tooltips: {
                        mode: 'label',
                    },
                    title: {
                        display: true,
                        text: this.title
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                // autoSkip : false,
                                // callback: function(value, index, values) {
                                //     return moment(value).format('MMM');
                                // }
                            },
                            gridLines : {
                                display : false,
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                min: 0,
                                stepSize: 10
                            }
                        }],
                    },
                }
            }
        },
        name: "BasicLineChart",
        mounted() {
            this.renderChart(this.chartdata, this.options)
        }
    }
</script>

<style scoped>

</style>
